var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-4 custom-callout rounded",
      attrs: { "border-color": "primary-2", "has-toggle": false }
    },
    [
      _c("div", { staticClass: "py-2" }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("icon-view", {
              staticClass: "mt-5 mb-3 mt-md-0 mt-sm-5",
              attrs: {
                gradient: false,
                icon: "fas fa-undo mb-1",
                "icon-color": "#ff7058",
                "icon-size": "16px",
                title: _vm.title
              }
            })
          ],
          1
        ),
        _c("div", [
          _c("div", { staticClass: "font-14 color-gray-6 mb-1" }, [
            _vm._v(" Comentario: ")
          ]),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.comment) + " ")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }